import {Component, Input} from "@angular/core";
import {DialogComponent} from '../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../ng2-bootstrap-modal/dialog.service';

@Component({
    selector: 'db-coupon-apply-response-dialog',
    templateUrl: './coupon-apply-response-dialog.component.html',
    styleUrls: ['./coupon-apply-response-dialog.component.scss'],
    standalone: false
})
export class CouponApplyResponseDialogComponent extends DialogComponent<null, Boolean> {

  @Input() headerText: string;
  @Input() messageText: string;
  @Input() buttonText: string;

  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

  public close_popup() {
    this.result = true;
    this.close();
  }
}
